const BaseCategoryPage = require('base/category-page');

const searchlTpl = Handlebars.templates['templates/rights-search-tpl'];
const listTpl = Handlebars.templates['templates/rights-case-category-list-tpl'];

class Category extends BaseCategoryPage {
  constructor () {
    super();
    this.pageSize = 10;
  }
  search () {
    const { showContent, code } = this.selectedTreeNode;
    const { articleId, PID, districtCode } = this.query.params;
    this.$content.find('.block__content').spin(); // 搜索前先旋转
    console.log(this.selectTreeNode);
    // 五种情况:后台详情预览、展示详情、展示列表、采购公告
    if (showContent && this.previewFlag) {
      this.renderPreview({ categoryCode: code, articleId, PID });
    } else if (showContent) {
      this.renderDetail({ categoryCode: code });
    } else {
      let payload = {
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        code
      };
      $.extend(payload, this.query.params);
      // 公告区划采前四位模糊匹配
      if (districtCode) {
        delete payload.districtCode;
        payload.wildcardDistrictCode = districtCode.slice(0, 4) + '*';
      }
      this.client
        .searchArticleByKeyWord(payload)
        .done((...res) => this.renderList(...res));
    }
  }

  renderList (resp) {
    const { total } = resp.hits;
    const now = new Date().toDateString();
    // 遍历数据判断是否为新增
    resp.hits.hits.map(({ _source }) => {
      _source.isNew = new Date(_source.publishDate).toDateString() === now;
      return _source;
    });
    this.$content.find('.block__content').html(
      listTpl({
        _DATA_: resp.hits,
        _pageSize_: this.pageSize || '10'
      })
    );
    this.$el.find('.block__content .total').text(total);
    this.initPagination(total);
  }

  initSearchPanel () {
    const { showContent = false } = this.selectedTreeNode;
    if (showContent) {
      this.$searchPanel.html('');
    } else {
      this.$searchPanel.html(searchlTpl);
    }
  }
}

module.exports = Category;
